import React from 'react';

// this component needs
//  -props text

class FormFeedback extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: this.props.show,
    };
  }

  componentDidUpdate(oldProps) {
    const newProps = this.props;
    if (oldProps.show !== newProps.show) {
      this.setState({ show: newProps.show });
    }
  }

  render() {
    return (
      <div
        className={
          this.state.show ? 'invalid-feedback show' : 'invalid-feedback'
        }
      >
        {this.props.text}
      </div>
    );
  }
}
export default FormFeedback;
